import $ from "jquery";
import _ from "underscore";
import Packery from "packery";
import imagesLoaded from "imagesloaded";
import StateManager from "../scuba/StateManager";

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function (event, node) {
  $(node)
    .find(".js-posts")
    .each(function (i, el) {
      new Posts(el);
    });
});

/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Posts() {
  this.initialize.apply(this, arguments);
}

$.extend(Posts.prototype, {
  initialize: function (el) {
    var self = this;
    self.uid = _.uniqueId("scuba-");
    self.$el = $(el);
    self.$list = self.$el.closest(".js-scuba__list");
    self.$sectionContent = self.$el.closest(".js-scuba__content");
    self.minWidth = 240;
    self.packery = new Packery(el, {
      itemSelector: ".js-post",
      transitionDuration: 0,
      percentPosition: true,
      gutter: 0,
      resize: false,
    });

    self.$sectionContent.on("widthChanged", self.relayout.bind(self));
    $(window).on("resize", self.relayout.bind(self));

    self.$el.find(".js-scuba__list__load-more").click();

    self.packery.on("layoutComplete", function () {
      self.$el.find(".new-post").removeClass("new-post");
    });

    if (self.$list.length) {
      self.$list.on("itemsChanged", function () {
        imagesLoaded(self.$list.get(0)).on("progress", function () {
          self.packery.reloadItems();
          self.relayout.bind(self)();
        });
      });
    }

    $(window).on(StateManager.STATE_CHANGE, function () {
      setTimeout(self.relayout.bind(self));
    });

    self.relayout.bind(self);
  },

  relayout: function () {
    var self = this;
    var viewportWidth = self.$el.width();
    var qty = Math.floor(viewportWidth / self.minWidth);
    var width = 100 / Math.max(qty, 1);

    self.$el.find(".js-post").css("width", `${width}%`);
    if (self.$el.closest(".js-home").length) {
      self.$el
        .find(".js-post.c-post--big")
        .css("width", `${width <= 50 ? 2 * width : width}%`);
    }
    self.packery.layout();
  },
});



// WEBPACK FOOTER //
// ./scripts/components/Posts.js